import React, { useEffect } from 'react'
import { getBuyerPackageHistories } from '../../services/packageServices.ts'
import { useAuth } from '../../context/AuthContext';
import { useState } from 'react';
import { Eye } from 'lucide-react';
import { useCurrencyUtils } from '../../utils/currencyUtils'; // ← updated import

const BuyerDeposit = () => {
  const { user } = useAuth();
  const [packageHistories, setPackageHistories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filterStatus, setFilterStatus] = useState('all'); // all, paid, pending

  // Check if there are any rejected packages
  const hasRejectedPackages = packageHistories.some(pkg => 
    pkg.isApproved == 0 && pkg.actionBy != null
  );

  // Currency utils (only change here)
  const { displayPriceWithSymbol } = useCurrencyUtils();

  useEffect(() => {
    if (user?.id) {
      fetchBuyerPackageHistories();
    }
  }, [user?.id]);

  const fetchBuyerPackageHistories = async () => {
    try {
      const response = await getBuyerPackageHistories(user.id, 1, 50);
      setPackageHistories(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching buyer package histories:", error);
      setError("Failed to load package information");
    } finally {
      setLoading(false);
      setError(null);
    }
  }

  return (
    <div className="space-y-2">
      {/* Header Section */}
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-white">
          Deposit History
        </h1>
      </div>

      {/* Order Table Section */}
      <div className="bg-card rounded-lg shadow-sm overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-page">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">
                  Plan Name
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">
                  Deposit
                </th>
               
                <th className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">
                  Bid Limit
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">
                  Car Limit
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">
                  Status
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">
                  Date
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">
                  View Receipt
                </th>
              </tr>
            </thead>
            <tbody className="">
              {packageHistories.map((packageHistory, index) => (
                  <tr key={index} className="border-b border-default hover:bg-page/70">
                  <td className="px-6 py-4 text-white">{packageHistory.name}</td>
                  <td className="px-6 py-4 text-white/70">
                    {displayPriceWithSymbol(Number(packageHistory.deposit))}
                  </td>
                  <td className="px-6 py-4 text-white/70">
                    {displayPriceWithSymbol(Number(packageHistory.creditLimit))}
                  </td>
                  <td className="px-6 py-4 text-white/70">{packageHistory.carLimit}</td>
                   <td className="px-6 py-4">
                     {packageHistory.isApproved == 0 && packageHistory.actionBy != null ? (
                       <span
                         className="px-2 py-1 rounded-full text-xs font-medium bg-red-700 text-white cursor-pointer relative group"
                         
                       >
                         Rejected
                         {packageHistory.rejectionNote && (
                           <span className="absolute left-1/2 -translate-x-1/2 bottom-full mb-2 w-60 bg-black text-white text-sm rounded p-2 opacity-0 group-hover:opacity-100 pointer-events-none z-10 transition-opacity duration-200 whitespace-pre-line">
                             {packageHistory.rejectionNote}
                           </span>
                         )}
                       </span>
                     ) : (
                       <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                         packageHistory.isApproved == 1
                           ? 'bg-green-700 text-white'
                           : 'bg-[#f64f2d] text-white'
                       }`}>
                         {packageHistory.isApproved == 1 ? 'Approved' : 'Pending'}
                       </span>
                     )}
                   </td>
                  <td className="px-6 py-4 text-white/70">{packageHistory?.actionAt
                            ? (() => {
                                const d = new Date(packageHistory.actionAt);
                                const day = d.getDate();
                                const month = d.getMonth() + 1;
                                const year = d.getFullYear();
                                return `${day}/${month}/${year}`;
                              })()
                            : "Not assigned"}</td>
                   <td className="px-6 py-4">
                     <button 
                       onClick={() => window.open(packageHistory.imageUrl, '_blank')}
                       className={`px-2 py-1 rounded-md transition-colors flex items-center gap-2 ${
                         packageHistory.isApproved == 0 && packageHistory.actionBy != null
                           ? 'bg-red-600 text-white hover:bg-red-700'
                           : 'bg-primary text-white hover:bg-primary-dark'
                       }`}
                     >
                       <Eye className="w-4 h-4" />
                       View
                     </button>
                   </td>
                </tr>
              ))}
              {packageHistories.length === 0 && (
                <tr>
                  <td colSpan="7" className="px-6 py-12 text-center text-white">
                  No Data Found.
                </td>
              </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

    </div>
  )
}

export default BuyerDeposit